import moment from 'moment';
import { forEach } from 'lodash';

import { prettifyNumber } from 'application/util/number.util';
import { getErrorMessage } from 'application/util/error.util';

import './income-expense-chart.style.sass';
import template from './income-expense-chart.tpl.pug';

class IncomeExpenseChartController {
    /* @ngInject */
    constructor(dashboardService) {
        this.dashboardService = dashboardService;
        
        this.options = this.getChartOptions();
    }

    $onInit() {
        this.loading = true;
    }

    $onChanges(changeObject) {
        if (changeObject.calendarIds || changeObject.year) {
            return this.load(
                this.calendarIds,
                moment([this.year]).startOf('year').valueOf(),
                moment([this.year]).endOf('year').valueOf()
            );
        }
    }

    getTooltipTitle(items, data) {
        return moment(data.labels[items[0].index]).format('MMMM');
    }

    getTooltipLabel(item, data) {
        let index = item.index;
        let datasetIndex = item.datasetIndex;

        // skip the one of the labels
        if (datasetIndex % 2 === 1) {
            return null;
        }

        let income = prettifyNumber(data.datasets[0].data[index], {
            preventShrink: true,
            pretty: true
        });

        let expense = prettifyNumber(data.datasets[1].data[index], {
            preventShrink: true,
            pretty: true
        });

        let change = prettifyNumber(data.datasets[0].data[index] - data.datasets[1].data[index], {
            preventShrink: true,
            addPositiveSign: true,
            pretty: true
        });

        return [
            `Income: ${income}`,
            `Expense: ${expense}`,
            `Change: ${change}`,
        ];
    }

    getBalanceTick(label) {
        return prettifyNumber(label);
    }

    getMonthTick(label) {
        return moment(label).format('MMM');
    }

    getChartOptions() {
        return {
            layout: {
                padding: {
                    left: 20,
                    top: 110
                }
            },
            tooltips: {
                yAlign: 'bottom',
                callbacks: {
                    title: this.getTooltipTitle.bind(this),
                    label: this.getTooltipLabel.bind(this)
                }
            },
            scales: {
                yAxes: [{
                    gridLines: {
                        color: '#ebeced',
                        borderDash: [3, 5],
                        zeroLineColor: '#ebeced',
                        zeroLineBorderDash: [3, 5],
                        drawBorder: false,
                        drawTicks: false
                    },
                    ticks: {
                        padding: 30,
                        maxTicksLimit: 5,
                        suggestedMin: 0,
                        suggestedMax: 0,
                        beginAtZero: true,
                        callback: this.getBalanceTick.bind(this)
                    },
                }],
                xAxes: [{
                    gridLines: {
                        display: false,
                        drawBorder: false,
                        drawTicks: false
                    },
                    ticks: {
                        maxTicksLimit: 12,
                        autoSkipPadding: 20,
                        padding: 15,
                        maxRotation: 0,
                        minRotation: 0,
                        callback: this.getMonthTick.bind(this)
                    },
                    barPercentage: 0.8,
                    categoryPercentage: 0.4,
                }]
            }
        };
    }

    load(calendarIds, start, end) {
        start = moment(start);
        end = moment(end);

        this.loading = true;

        let labels = [];
        let income = [];
        let expense = [];

        return this.dashboardService.getIncomeExpenseData(calendarIds, start.isValid() ? start.valueOf() : null, end.valueOf()).then((dataSet) => {
            forEach(dataSet, (month) => {
                labels.push(month.timestamp);
                income.push(month.income);
                expense.push(month.expense);
            });

            this.error = null;
        }).catch((result) => {
            this.error = getErrorMessage(result, `Unfortunately we couldn't load the chart data. Please try again later.`);
        }).finally(() => {
            this.data = {
                labels,
                datasets: [
                    this.getDataSet(income, '#1196ea'),
                    this.getDataSet(expense, '#e55264')
                ]
            };

            this.loading = false;
        });
    }

    getDataSet(data, color) {
        return {
            data,
            fill: true,
            backgroundColor: color,
            hoverBackgroundColor: color
        };
    }
}

export default {
    selector: 'dbAIncomeExpenseChart',
    template: template(),
    controller: IncomeExpenseChartController,
    bindings: {
        calendarIds: '<',
        year: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/income-expense-chart/income-expense-chart.cmpt.js